import { Form } from 'react-bootstrap';

export default function Label({ label, className = '' }) {
  if (!label) return null;

  const requiredLabel = label.includes('*');
  const finalLabel = requiredLabel ? label.replace('*', '') : label;

  return (
    <Form.Label column xs={12} className={className}>
      {finalLabel} {requiredLabel && <p className="MarkupRequiredField">*</p>}
    </Form.Label>
  );
}
